export interface LocationProvider {
    getCurrent(): string,
}

export class WindowLocationProvider implements LocationProvider {
    getCurrent(): string {
        return window.location.href;
    }
}
